// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2__Y6","insightsList":"newBusinessInsightsMenu_insightsList__17AoI","active":"newBusinessInsightsMenu_active__nJVpJ"};